import React, {ComponentProps, Fragment} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Link, useHistory} from "react-router-dom";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/suit";
import {useRequest} from "ahooks";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import dayjs from "dayjs";
import Divider from "../../components/Divider";
import {Button, Form, Popconfirm, Space, Select, Input} from "antd";
import styles from "./index.module.css";
import withAuth from "../../utils/withAuth";

const AddButton = withAuth('add', Button);
const StatusButton = withAuth('updateStatus', Button);
const DeletePopconfirm = withAuth('delete', Popconfirm);

function Suit(props: ComponentProps<any>) {
    const history = useHistory();

    const {tableProps, refresh, form, search} = useAntTable(api.getSuits, {});
    const {loading: loadingDelete, run: deleteSuit} = useRequest(api.deleteSuit, {
        manual: true,
        onSuccess() {
            refresh();
        }
    });

    const {loading: loadingUpdateStatus, run: updateStatus} = useRequest(api.updateStatus,{
        manual: true,
        onSuccess(){
            refresh();
        }
    })

    const handleDelete = (id: number) => {
        deleteSuit(id);
    }

    let columns: StandardColumnsType = [
        {
            title: '套餐编号',
            dataIndex: 'code'
        },
        {
            title: '套餐名称',
            dataIndex: 'name'
        },
        {
            title: '产品线',
            dataIndex: 'categoryName',
            render: (value?: string) => value?.replace("//", '')?.replaceAll('/', ' / ')
        },
        {
            title: '备注',
            dataIndex: 'remark'
        },
        {
            title: '开始日期',
            dataIndex: 'startDate',
            render: value => value ? dayjs(value).format('ll') : null
        },
        {
            title: '结束日期',
            dataIndex: 'endDate',
            render: value => value ? dayjs(value).format('ll') : null
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: value => value ? '启用' : '停用'
        },
        {
            title: '操作',
            dataIndex: 'operation',
            render(_, record: any) {
                return (
                    <Divider>
                        <Link to={`/product/suit/detail/${record.id}`}>详情</Link>
                        <StatusButton type={'link'} loading={loadingUpdateStatus} onClick={()=>updateStatus(record.id, !record.status)}>{record.status? '停用' : '启用'}</StatusButton>
                        <DeletePopconfirm title={'是否确认删除套餐'} onConfirm={()=>deleteSuit(record.id)}>
                            <a style={{color: 'var(--danger-color)'}}>删除</a>
                        </DeletePopconfirm>
                    </Divider>
                )
            }
        }
    ]


    const searchBar = (
        <Form form={form} className={styles.ToolBar}>
            <Space className={styles.SearchBar}>
                <Form.Item name={'status'} initialValue={null}>
                    <Select>
                        <Select.Option key={0} value={null}>全部</Select.Option>
                        <Select.Option key={1} value={true}>启用</Select.Option>
                        <Select.Option key={2} value={false}>停用</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item name={'code'} initialValue={null}>
                    <Input placeholder={'套餐编号/套餐名称'} allowClear/>
                </Form.Item>
                <Button onClick={search.reset}>重置</Button>
                <Button onClick={search.submit} type={"primary"}>搜索</Button>
            </Space>
        </Form>
    );

    const toolbar = (
        <>
            {searchBar}
            <Space>
                <Divider>
                    <AddButton type={"primary"} onClick={()=>history.push('/product/suit/add')}>新增</AddButton>
                </Divider>
            </Space>
        </>

    );

    return (
        <PageHeaderLayout>
            <StandardTable {...tableProps} columns={columns} form={form} search={search} rowKey={'id'} toolbar={toolbar}/>
        </PageHeaderLayout>
    )
}

export default Suit;